import { Divider, Tab, Tabs } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { style } from './style';

type TabArr = {
  label: string,
  value: string,
  isError?: boolean,
}

type TabsNavigationProps = {
  onNavigateClick: (tab: string) => void,
  tabArr: TabArr[],
  currentTab: string,
}

export const TabsNavigation = ({
  onNavigateClick,
  tabArr,
  currentTab,
}:TabsNavigationProps):JSX.Element => {
  return (
    <Box sx={ style.tabsContainer.sx }>
      <Tabs value={ currentTab }
        onChange={ (event: React.SyntheticEvent, newValue: string) => {
          onNavigateClick(newValue);
        } }
      >
        {tabArr.map((item: TabArr) => {
          return (
            <Tab
              sx={ style.errorTab.sx(!!item.isError) }
              value={ item.value }
              key={ item.value }
              label={ item.label }
            />
          );
        })}
      </Tabs>
      <Divider />
    </Box>
  );
};
